import { shopifyGql } from '../shopify_client/graphql'
import {
  ICart,
} from '../shopify_client/types'
import { cartFragment } from './fragments'

export async function fetchCart(cartID: string): Promise<ICart> {
  const body = await shopifyGql<ICartQuery>(
    cartQuery,
    { cartID }
  )
  const cart: ICart = body.data.cart
  return cart
}

export interface ICartQuery {
  cart: {
    __typename: 'Cart',
  } & ICart
}

const cartQuery = `
query cartQuery($cartID: ID!) {
  cart(id: $cartID) {
    ...CartFragment
  }
}
${cartFragment}
`
